import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { aosColor, IconComponent, TableColumn } from '@ui/aos-lib';
import { OperationDate } from 'src/app/pages/equipment/field-operations/ui/field-operations.types';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
  template: `
    @for (dataItem of data(); track $index) {
      <div class="f-center cell">
        @if (!dataItem.date) {
          <ui-icon
            [name]="'not-checked'"
            [color]="color.grayscale300"
          ></ui-icon>
        } @else {
          <ui-icon
            [name]="'checked'"
            [color]="color.primary500"
          ></ui-icon>
          <span>{{ dataItem.date }}</span>
        }
      </div>
    }
  `,
  styles: `
    @use 'variables' as *;
    .cell + .cell {
      margin-top: 0.5rem;
    }
  `
})
export class CheckmarkColumnComponent {
  item = input.required<{ [key: string]: OperationDate[] | null }>();
  column = input.required<TableColumn>();

  protected readonly color = aosColor;
  protected data = computed(() => this.item()[this.column().field]);
}
